import { useGetFinancialProgramsQuery } from "../internal/entities/credit/api/api.js";
import "../internal/entities/credit/model/selectors/selectCreditLimits.js";
import "../internal/entities/credit/model/selectors/selectCreditLimitsParams.js";
import "../internal/entities/credit/model/selectors/selectFinancialPrograms.js";
import { selectFinancialProgramsParams } from "../internal/entities/credit/model/selectors/selectFinancialProgramsParams.js";
import "../internal/entities/credit/model/selectors/selectInitialCreditLimits.js";
import { selectSelectedFinancialProgram } from "../internal/entities/credit/model/selectors/selectSelectedFinancialProgram.js";
import { useAppSelector } from "../internal/shared/lib/store/hooks/useAppSelector.js";
function useFinancialPrograms() {
  const financialProgramsParams = useAppSelector(selectFinancialProgramsParams);
  const selected = useAppSelector(selectSelectedFinancialProgram);
  const isSkipFinancialProgramsQuery = !financialProgramsParams;
  const {
    requestId,
    currentData = [],
    data = currentData,
    isUninitialized: isUninitializedQuery,
    isLoading: isLoadingQuery,
    isFetching: isFetchingQuery
  } = useGetFinancialProgramsQuery(financialProgramsParams, {
    skip: isSkipFinancialProgramsQuery
  });
  const isLoading = !isSkipFinancialProgramsQuery && (isUninitializedQuery || isLoadingQuery || isFetchingQuery);
  return {
    requestId,
    data: isSkipFinancialProgramsQuery ? [] : data,
    selected,
    isLoading
  };
}
export {
  useFinancialPrograms
};
